import React, { useEffect } from "react";
import { useOutletContext, Link } from "react-router-dom";
import "../css/Page__Styles.css";
import "../css/Page__ProjectDirectory.css";
import projectsData from "../data/projects.json";
import Footer from "../components/Footer.jsx"
import ProjectGrid from "../components/ProjectGrid.jsx";

export const ProjectDirectory = () => {

  useEffect(() => {
      document.title = "Eme / Proyectos";
    }, []);

  const { setHeaderLinksColor } = useOutletContext() || {};

  return (
    <div>

      <section className="page_project_directory">

        <h2>Cada proyecto nace de una mirada propia. Mi misión es comprenderla, darle forma y crear las conexiones, formas y detalles que la conviertan en una identidad única, coherente y con carácter.</h2>
        <div>
          <ProjectGrid projects={projectsData} />
        </div>
        
      </section>

      <Footer />

    </div>
  );
};

export default ProjectDirectory;
